import * as React from "react";

function SvgStripTShirt(props) {
  return <svg id="stripTShirt_svg__Calque_1" xmlns="http://www.w3.org/2000/svg" x={0} y={0} viewBox="0 0 40 40" xmlSpace="preserve" width="1em" height="1em" {...props}><style>{".stripTShirt_svg__st1{fill:#1c3e8e}"}</style><circle cx={20} cy={20} r={20} fill="#c0c4c7" /><path className="stripTShirt_svg__st1" d="M40 20c0-1-.1-2-.2-3H.2c-.1 1-.2 2-.2 3 0 1.4.1 2.7.4 4h39.2c.3-1.3.4-2.6.4-4zM30.5 3h-21c-2.8 1.7-5.1 4.1-6.8 7h34.6c-1.7-2.9-4-5.3-6.8-7zM36.7 31H3.3c2 3 4.8 5.4 8 7h17.3c3.3-1.6 6.1-4 8.1-7z" /></svg>;
}

export default SvgStripTShirt;